<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addEditProcurement></addEditProcurement>
    </v-dialog>
</template>

<script>
    import addEditProcurement from '../Shared/AddProcurement.vue'

    // Settings Types
    import {
        Procurement
    } from '../../store/namespace-helper'

    export default {
      name: 'purchase-order-dialog',
      components: {
        addEditProcurement
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[Procurement.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Procurements/AddProcurementDialog.vue